<template>
    <router-view :userDetail="userDetail" />
</template>

<script>
    import { zones } from '@/api/zone.js'
    import { user } from "@/api/user.js";
    export default {
        data() {
            return {
                userDetail: Array
            }
        },
        created() {
            if(window.location.href.indexOf('czyjsgk.com') > 0){
                window.location.href = window.location.href.replace('czyjsgk.com','yjsgk.top')
            }
            let prefix = window.location.host.split(".")[0];
            let tertiaryDns = window.location.host.split(".")[1];
            let openYear = Number('20' + tertiaryDns.substring(0,2))
            let openType = tertiaryDns.substring(2,4)
            this.$store.commit('changeopenYear',openYear)
            this.$store.commit('changeopenType',openType)
            this.$nextTick(() => {
                if (prefix == 'wenzhou') {
                    return
                }
                if (this.$cookies.get('session')) {
                    if (this.isIp()) {
                        zones().then(res => {
                            let district = res.zones.find(ele => ele.id == this.$cookies.get('zone') && ele.type == openType && ele.year == openYear).district
                            this.$cookies.set('district', district, '0');
                        })
                    } else if (!this.$cookies.get('zone') || this.$cookies.get('zone') == null || this.$cookies.get('district') == null) {
                        zones({code: prefix, year: openYear,type: openType }).then(res => {
                            this.$cookies.set("zone", res.zones[0].id, '0')
                            this.$cookies.set('district', res.zones[0].district, '0');
                            if (localStorage.getItem('city')) {
                                localStorage.setItem('city', res.zones[0].ad);
                            }
                            if (localStorage.getItem('titlename')) {
                                localStorage.setItem('titlename', encodeURIComponent(res.zones[0].name));
                            }
                            if (localStorage.getItem('type')) {
                                localStorage.setItem('type', res.zones[0].type == 0 ? 'Ԥ��' : '����');
                            }
                            this.init()
                        })
                    }
                }
                if (this.$cookies.get('session') && this.$cookies.get('zone')) {
                    this.init()
                }
            })
        },
        methods: {
            isIp() {
                if (/^(\d+)\.(\d+)\.(\d+)\.(\d+)$/.test(window.location.hostname)) {
                    if (RegExp.$1 < 256 && RegExp.$2 < 256 && RegExp.$3 < 256 && RegExp.$4 < 256)
                        return true
                } else {
                    return false
                }
            },
            init() {
                let host=window.location.host.split(".")
                if (host[0] == 'wenzhou') {
                    return
                }
                if (window.location.pathname != '/public' && window.location.pathname != '/public/divs' && window.location.pathname != '/public/div') {
                    user().then(res => {
                        this.userDetail = res
                        this.$store.commit("changeUserDetail", res);
                        res.scope.forEach(ele => {
                            if (localStorage.getItem('divid') && ele.value == localStorage.getItem('divid')) {
                                localStorage.setItem('lxfsType', true)
                            } else {
                                localStorage.removeItem('lxfsType')
                            }
                        })
                        res.status == 0 && res.roles.length > 0 ? localStorage.setItem('name', res.roles[0].name) : localStorage.removeItem('name')
                        res.permissions.find(ele => ele == "4f1f128a0eac400286abff021d8e1b40") ? localStorage.setItem('divListType', true) : localStorage.removeItem('divListType')
                        res.permissions.find(ele => ele == "0fceb184892645638b0e1652f56ce5a9") ? localStorage.setItem('setType', true) : localStorage.removeItem('setType')
                        res.permissions.find(ele => ele == "eb8bd9764da64dd6b16e4fc68d634f2e") ? localStorage.setItem('resetType', true) : localStorage.removeItem('resetType')
                    })
                }

            }
        }
    }
</script>

<style>
    html, body, #app {
        padding: 0px;
        margin: 0px;
        height: 100%;
    }

    p, h1, h2, h3, h4 {
        margin: 0px;
        padding: 0px;
    }

    .search {
        color: #fff !important;
        background-color: #4178be !important;
        box-shadow: 0 2px 4px -1px rgba(0, 0, 0, .2), 0 4px 5px 0 rgba(0, 0, 0, .14), 0 1px 10px 0 rgba(0, 0, 0, .12);
        position: relative;
        height: 65px;
    }

    .gongneng {
        /* float: right;
        width: 40%;
        text-align: right; */
        position: absolute;
        right: 0;
    }

        .gongneng span {
            width: 47px;
            height: 51px;
            padding: inherit;
            display: inline-block;
            cursor: pointer;
            text-align: center;
            margin: 7px;
            -webkit-transition: .1s;
            transition: .1s;
            border-radius: 4px;
            background: #e5f2ff !important;
            border-color: #e5f2ff !important;
            box-shadow: 0 2px 4px -1px rgba(0, 0, 0, .2), 0 4px 5px 0 rgba(0, 0, 0, .14), 0 1px 10px 0 rgba(0, 0, 0, .12);
        }

            .gongneng span img {
                padding-top: 3px;
            }

    .content .unwriten .el-input__inner, .unwriten .el-textarea__inner {
        background-color: #ffe5e5 !important;
    }

    .el-input__inner, .el-textarea__inner {
        font-family: fangsong !important;
        font-size: 20px !important;
    }

    .divs .el-input__inner {
        font-family: fangsong !important;
        font-size: 15px !important;
    }

    .tips {
        position: sticky;
        top: 0;
        z-index: 99;
    }

    .el-input__suffix {
        text-indent: 0em !important;
    }

    .tipsText {
        color: red;
        font-style: italic;
        
    }
    .tipsText img {
        line-height: 20px;
        height: 20px;
        width: 20px;
    }
    .red{
        color:red
    }
</style>
